import { useFormData } from "../contexts/FormData";

const useRequestItems = () => {
   const { formValues = {}, setFormValues } = useFormData() || {};

  const removeItem = (id, arr, field = "sku") => {
    setFormValues(oldObj => {
      // Create a new array with the item filtered out
      const filteredArray = oldObj[arr].filter(item => item[field] !== id);
      // Return a new object with the updated array
      return {
        ...oldObj,
        [arr]: filteredArray
      };
    });
  };

  const editItem = (e, arr, sku, field) => {
    const val = e.target.value;
    
    setFormValues(oldObj => {
      // Check if the array exists in the oldObj
      if (!oldObj[arr]?.length) {
        return oldObj; // Nothing to edit
      }
      // Create a deep copy of the array
      const newItems = [...(oldObj[arr] || [])];
      // Find the item to edit
      const itemIndex = newItems.findIndex(el => el.sku === sku);
      // If item not found, return unchanged state
      if (itemIndex === -1) {
        return oldObj;
      }
      // Create a new item object with the updated field
      const updatedItem = {
        ...newItems[itemIndex],
        [field]: val
      };
      // Replace the old item with the updated one
      newItems[itemIndex] = updatedItem;
      // Return a new object with the updated array
      return {
        ...oldObj,
        [arr]: newItems
      };
    });
  };

  const addWigCode = (wig) => {
    let code = wig.wig_id?.toUpperCase();
    setFormValues(oldObj => {
      const findCode = oldObj.wigs.find(el => el.wig_id === code)
      if (findCode) {
        return oldObj;
      }
      return {
        ...oldObj,
        wigs: oldObj.wigs.concat(wig)
      };
    });
  }

  return { removeItem, editItem, setFormValues, formValues, addWigCode };
};

export default useRequestItems;